import { createAPI } from '@common'
//  MediaCloudPublishCenterMobile
export default {
  // 送审记录读取接口
  getArticlesTransferList: (config) =>
    createAPI('customEncryptApiName-1/0w20bsujdmft0usbotgfs0mjtu', 'get', config),
  // 稿件签发信息
  getArticlesIssues: (config) =>
    createAPI('customEncryptApiName-1/0w20bsudjmft0jttvft', 'get', config),
  // 稿件签发
  postArtcilesIssue: (config) => createAPI('customEncryptApiName-1/w20bsujdmft0jttvf', 'post', config),
  // 已关联栏目接口
  getArtcilesColumnrel: (config) =>
    createAPI('customEncryptApiName-1/0w20bsujdmft0dpmvnosfm', 'get', config),
  // 稿件简要信息
  getArticlesSimpleInfo: (config) =>
    createAPI('customEncryptApiName-1/0w20bsujdmft0tjnqmfJogp', 'GET', config),
  // 按id获取稿件详情接口
  getArticlesDetailByID: (config) =>
    createAPI('customEncryptApiName-1/w20bsujdmft0efubjm0czJE', 'GET', config),
  // 签发初始化接口
  getArticlesIssueInitialization: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20bsujdmft0jttvf0jojujbmj{bujpo',
        'GET',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20bsujdmft0jttvf0jojujbmj{bujpo',
        'GET',
        { params: config.params },
        null
      )
    }
  },
  // 稿件预览
  postArticlesAppPreview: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;w20bsujdmft0bqqQsfwjfx',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/w20bsujdmft0bqqQsfwjfx',
        'post',
        { data: config.data },
        null
      )
    }
  },
  // 稿件预览——走新模板的接口
  postArticlesNewPreview: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;w20bsujdmft0ofxQsfwjfx',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/w20bsujdmft0ofxQsfwjfx',
        'post',
        { data: config.data },
        null
      )
    }
  },
  /* *****************************************这上面的都是老的接口没有用啊**************************************** */

  // 文章是否包含图片
  postNewseditAttachmentsCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0buubdinfout0difdl', 'post', config),
  // 送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0usbotgfs', 'post', config),
  // 审核完成
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0qbtt', 'post', config),
  // 撤稿
  postArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0sfwplf', 'post', config),
  // 驳回
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0sfkfdu', 'post', config),
  // 校核完成
  postArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0qsppg', 'post', config),
  //查询被占用的早晚报数组
  getArticlesSpecialDailyPaperDate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tqfdjbm0ebjmzQbqfsEbuf',
      'get',
      config
    ),
  //查询早晚报最近一期可写稿的日期和早晚报类型
  getNextDailyPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tqfdjbm0ofyuEbjmzQbqfs',
      'get',
      config
    ),
  // 稿件置顶
  postArticlesSortingTop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0upq', 'post', config),
  // 发布
  postArticlesPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0qvcmjti', 'post', config),
  // 签发稿件到报纸
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0qbqfs0tjho0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 签发稿件到全媒体采编发（发布用的也是这个接口
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0jttvf', 'post', config, {
      timeout: 90000
    }),
  // 固定位置设置
  postArticlesSortingPosition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0qptjujpo', 'post', config),
  // 通过id获取稿件主栏目和关联栏目
  getArticleColumnAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0hfuBsujdmfDpmvnoBmm',
      'get',
      config,
      {
        neverLoading: true
      }
    ),
  // 保存关联接口
  putArtcilesColumnrel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0dpmvnosfm', 'put', config),
  // 解除关联
  deleteArtcilesColumnrel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0dpmvnosfm', 'delete', config),
  // 原稿会彻底删除，发布库稿件会设删除标记
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0efmfuf', 'post', config),
  // 移动
  putArtcilesMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0npwf', 'put', config, {
      timeout: 60000
    }),
  // 复制
  postArtcilesCopy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0dpqz', 'post', config, {
      timeout: 60000
    }),
  // 置顶,固定位置获取过期时间
  getArticlesSortingExpireTime: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0fyqjsfUjnf', 'get', config),
  // 获取当前稿件轮播数据
  getArticlesSortingCarouselPosition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0dbspvtfmQptjujpo',
      'get',
      config
    ),
  // 设置当前稿件轮播数据
  postArticlesSortingMoveCarousel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0npwfDbspvtfm',
      'POST',
      config
    ),
  // 获取指定位置是否已存在轮播稿件
  getArticlesSortingUsedCarouselPosition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0vtfe0dbspvtfmQptjujpo',
      'GET',
      config
    ),
  // 取消轮播
  postArticlesSortingCancelCarousel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0dbodfmDbspvtfm',
      'POST',
      config
    ),
  // 获取阅读数设置
  getArticleSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tfuujoh', 'GET', config),
  // 保存阅读数设置
  postArticleSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tfuujoh', 'POST', config),
  // 获取点赞数设置
  getArticlePraiseSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tfuujoh0qsbjtf', 'GET', config),
  // 保存点赞数设置
  postArticlePraiseSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tfuujoh0qsbjtf', 'POST', config),
  // 修改发布时间
  postArticlePubTime: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0qvcUjnf', 'POST', config),
  getAppColumnsSearch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0tfbsdi', 'get', config, {
      neverLoading: true
    }),
  getWebColumnSearch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnoxfct0tfbsdi', 'get', config, {
      neverLoading: true
    }),
  // 移动调序（跨页调序）========= 检查是否置顶或固定位置
  postArticleSortingCheckTopOrPosition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0difdlUpqPsQptjujpo',
      'POST',
      config
    ),
  // 移动调序（跨页调序）========= 移动调序接口
  postArticleSortingMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tpsujoh0npwf', 'POST', config),

  // 流程记录
  getE5ActionsLogs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60bdujpot0mpht', 'get', config, vconfig),

  // 读当前用户可访问的报纸列表（全媒体采编发提供的接口）
  getNewseditUserPapersNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0vtfst0qbqfst', 'get', config),
  // 读当前用户可访问的报纸的栏目列表（全媒体采编发提供的接口）
  getNewseditUserPapersColumnsNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0vtfst0qbqfst0dpmvnot',
      'get',
      config
    ),
  // 给定一个栏目，读出版面列表（全媒体采编发提供的接口）
  getNewseditUserPapersLayoutsNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0vtfst0qbqfst0mbzpvut',
      'get',
      config
    ),
  // 获取拥有图片制作人员的名单（全媒体采编发提供的接口）
  getNewseditPicmakeUsersNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0qjdnblf0vtfst', 'get', config, {
      neverLoading: true
    }),
  // 签发稿件到全媒体采编发（全媒体采编发提供的接口）
  postNewseditArticlesForwardNew: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0ofxtfeju0bsujdmft0gpsxbse', 'post', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 内容快运批量解析接口
  postAdminExtractor: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0oslz0fyusbdups', 'POST', config, {
      ...vconfig,
      timeout: 120000
    }),
  // 内容快运稿件初始化
  postInitArticle: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0oslz0jojuBsujdmf', 'POST', config, {
      ...vconfig,
      timeout: 120000,
      isSimpleSecurity: true
    }),
  changeAttriCol: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0dibohfBuusjcvujpoDpm',
      'get',
      config
    ),
  /* ********************************下面是确定拆分app稿件独有********************************** */
  // 微信稿件详情
  getWXArticlesDetail: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfxy0bsujdmft0ofx0efubjm',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0ofx0efubjm',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 推送客户端
  postArticlesSharePush: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qvti0qvti', 'post', config),
  // 操作-推送至APP-是否推送过
  getArticlesSharePushCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qvti0qvti0difdl', 'get', config),
  // 稿件详情(统一用)
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0ofx0efubjm', 'get', config),
  // 稿件详情
  getArticlesDetail: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfbqq0bsujdmft0ofx0efubjm',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0ofx0efubjm',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // app发布库、网站发布-写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0ofx0dsfbujpo0joju', 'get', config),
  // app发布库、网站发布-写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0ofx0dsfbuf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 新-稿件预览
  postNewPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0ofxQsfwjfx', 'post', config),
  // 新-稿件详情预览
  getArticleContent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.fousz.bqq0bqq0qsfwjfx0bsujdmfDpoufou', 'get', config),
  // APP管理操作获取权限(广告
  getApAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0benjo0qfsnjttjpot0bdujpot0bqqbenjo',
      'get',
      config
    ),
  // APP管理操作获取权限(评论
  postApAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0benjo0qfsnjttjpot0bdujpot0bqqbenjo',
      'post',
      config
    ),
  // APP管理权限保存(广告
  getDiscussAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0benjo0qfsnjttjpot0bdujpot0bqqbenjo',
      'get',
      config
    ),
  // APP管理权限保存(评论
  postDiscussAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0benjo0qfsnjttjpot0bdujpot0bqqbenjo',
      'post',
      config
    ),
  // APP管理权限保存(电视广播
  getTVAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0benjo0qfsnjttjpot0bdujpot0bqqbenjo',
      'get',
      config
    ),
  // APP管理权限保存(电视广播
  postTVAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0benjo0qfsnjttjpot0bdujpot0bqqbenjo',
      'post',
      config
    ),
  // 发布栏目树拖动排序
  postNewColumnsDrag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0esbh', 'post', config),
  // APP获取直播列表
  postLive5listData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0f60mjtuEbub', 'post', config),
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60bdujpot0efubjmbdujpot', 'get', config),
  // 栏目详情
  getColumnDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0dpmvnoEfubjm', 'get', config),
  // 获取会员分组列表
  getMemberGroup: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0nfncfs0hspvq', 'get', config),
  // 还原已删除稿件
  postArticleRevert: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0bsujdmfSfwfsu',
      'post',
      config,
      vconfig
    ),
  // 彻底删除已删除稿件
  postArticleDeleteReal: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0efmfufSfbm',
      'post',
      config,
      vconfig
    ),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0efubjm0tubuvt', 'get', config),
  // 判断是否有回收站权限
  getRecycleRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0sppuEfmfuf', 'get', config),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  // 跨渠道关联接口
  postChannelRel: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0diboofmSfm',
      'post',
      config,
      vconfig
    ),
  // 跨渠道解除关联接口
  postChannelRelCancel: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0diboofmSfmDbodfm',
      'post',
      config,
      vconfig
    ),

  // 小样重稿-获取文章相似稿列表
  getSimilarList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0tjnjmbs0mjtuebub', 'get', config),
  // 小样重稿-获取文章相似稿详情
  getSimilarDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0tjnjmbs0efubjm', 'get', config),
  // 获取会员操作权限按钮
  getOperationAuth: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuPqfsbujpoBvui', 'post', config),
  // 保存会员操作权限配置
  saveOperationAuth: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0tbwfPqfsbujpoBvui', 'post', config),
  // 获取会员操作权限配置
  getOperationAuthConfig: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuPqfsbujpoBvuiDpogjh', 'post', config),

  // 定时撤稿操作
  postTimeRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0ujnfSfwplf', 'post', config),
  // 导出
  postArticlesExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0fyqpsu', 'post', config)
}
